import { useFormik } from "formik";
import TextInput from "../../components/inputs/textInput";
import TextArea from "../../components/inputs/textArea";
import Button from "../../components/buttons/button";
import { useTranslation } from "react-i18next";
import Select from "../../components/select/select";
import * as yup from "yup";
import axios from "axios";

const OfferPrice = () => {
  const { t } = useTranslation();

  const yupSchema = yup.object().shape({
    name: yup.string().required(t("requiredField")),

    email: yup
      .string()
      .email(t("invalidEmail"))
      .required(t("requiredField")),

    phone: yup.string().required(t("requiredField")),

    receipt: yup.string().required(t("requiredField")),

    import: yup.string().required(t("requiredField")),

    pickup: yup.string().required(t("requiredField")),

    // service: yup
    //   .object()
    //   .nullable()
    //   .required(t("requiredField")),

    details: yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      receipt: "",
      import: "",
      pickup: "",
      service: null,
      details: "",
    },

    validationSchema: yupSchema,

    onSubmit: async (values, { resetForm }) => {
      try {
        const response = await axios.post(
          "https://ba7ary.draconiccode.com/public/api/quote-requests",
          {
            full_name: values.name,
            email: values.email,
            phone: values.phone,
            pickup_country: values.receipt,
            import_country: values.import,
            pickup_city: values.pickup,
            service_type: values.service?.value,
            details: values.details,
          }
        );

        console.log(response.data);

        alert("Request sent successfully");

        resetForm();
      } catch (error) {
        console.log(error.response?.data || error.message);

        alert("Something went wrong");
      }
    },
  });

  const offerPriceOptions = [
    {
      label: t("landShipping"),
      value: "Land Shipping",
    },
    {
      label: t("seaShipping"),
      value: "Sea Shipping",
    },
    {
      label: t("airShipping"),
      value: "Air Shipping",
    },
    {
      label: t("customClearance"),
      value: "Custom Clearance",
    },
  ];

  return (
    <main>
      <div className="w-11/12 py-10 mx-auto">
        <h1 className="text-mainBlue font-semibold text-[32px] text-center pb-10">
          {t("requestOfferPrice")}
        </h1>

        <form
          onSubmit={formik.handleSubmit}
          className="p-10 bg-white rounded-3xl shadow-secondaryShadow"
        >
          <div className="inputs">
            <TextInput
              formik={formik}
              label={t("fullName")}
              placeholder={t("enterFullName")}
              name="name"
            />

            <TextInput
              formik={formik}
              label={t("emailAddress")}
              placeholder={t("enterEmail")}
              name="email"
            />
          </div>

          <div className="inputs">
            <TextInput
              formik={formik}
              label={t("phoneNumber")}
              placeholder={t("enterPhoneNumber")}
              name="phone"
            />

            <TextInput
              formik={formik}
              label={t("receiptCountry")}
              placeholder={t("enterReceiptCountry")}
              name="receipt"
            />
          </div>

          <div className="inputs">
            <TextInput
              formik={formik}
              label={t("importCountry")}
              placeholder={t("enterImportCountry")}
              name="import"
            />

            <TextInput
              formik={formik}
              label={t("pickUpCity")}
              placeholder={t("enterPickUpCity")}
              name="pickup"
            />
          </div>

          <div className="oneInput">
            <Select
              options={offerPriceOptions}
              formik={formik}
              label={t("typeOfService")}
              placeholder={t("selectTypeOfService")}
              name="service"
            />
          </div>

          <div>
            <TextArea
              formik={formik}
              label={t("details")}
              placeholder={t("provideDetails")}
              name="details"
            />
          </div>

          <Button
            text={t("submit")}
            className="bg-mainRed"
          />
        </form>
      </div>
    </main>
  );
};

export default OfferPrice;